import { SvgIcon, SvgIconProps } from '@mui/material'

const RefillPackIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props}>
    <path id="Path_1113" data-name="Path 1113" d="M19.69,2.94h-.46v-1a.68.68,0,0,0-.68-.68H14.68a.69.69,0,0,0-.68.67V2.94h-.45l-.63-1.6A2.08,2.08,0,0,0,11,0H7.32A2.07,2.07,0,0,0,5.37,1.34l-.64,1.6h-.1a2,2,0,0,0-2,2h0V22a2,2,0,0,0,2,2H19.69a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2h0M7,2a.33.33,0,0,1,.3-.2H11a.33.33,0,0,1,.3.2l.38,1h-5ZM19.23,19.63a1.09,1.09,0,0,1-1.09,1.09h-12a1.1,1.1,0,0,1-1.1-1.08h0V8.23a1.1,1.1,0,0,1,1.1-1.1h12a1.09,1.09,0,0,1,1.1,1.09h0Z" />
  </SvgIcon>
}

export default RefillPackIcon
